<template>
  <div>
    <Main
      ref="main"
      :disabled="disabled"
      :loading="loading"
      :tablePage="page"
      :tableData="tableData"
      @reload="getData"
    >
      <div slot="header">
        <div class="d-flex">
          <div class="side-frame-danger"></div>
          <div>
            <span style="font-size: 14px; color: #606266">
              {{ $l('table_title_orderFile') || '采购订单文件' }}
            </span>
            <el-divider direction="vertical" v-if="!disabled"></el-divider>
            <b-button
              v-if="!disabled"
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="uploadFiles()"
            >
              {{ $l('btn_uploadOrderFile') || '上传采购订单' }}
            </b-button>
          </div>
        </div>
      </div>
    </Main>
  </div>
</template>
<script>
import { VXETable } from 'vxe-table'
import Main from './main.vue'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [BaseTable, EditLoading],
  components: { Main },
  props: {
    disabled: { type: Boolean, default: false },
    amzReplenishmentCode: { type: String, default: '' },
  },
  data() {
    return {
      loading: false,
      tableData: [],
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.amzReplenishmentCode) return
      this.loading = true
      const res = await this.$api
        .ecomAmzVcOrderFilesListApi({
          amzReplenishmentCode: this.amzReplenishmentCode,
        })
        .catch(() => null)
      this.loading = false
      if (!res) return
      this.tableData = res.body.data
    },
    async uploadFiles() {
      const { file } = await VXETable.readFile({
        types: ['csv', 'CSV', 'xlsx', 'XLSX'],
      }).catch(() => ({}))
      if (!file) return

      if (this.loadingOpen()) return

      const uploadRes = await this.$api.SYS_UPLOAD(file).catch(() => null)
      if (!uploadRes) return this.loadingClose()

      const { fileId: fileMd5, url: fileUrl } = uploadRes.body
      const params = {
        fileMd5,
        fileUrl,
        originalFileName: file.name,
        amzReplenishmentCode: this.amzReplenishmentCode,
      }

      const res = await this.$api
        .ecomAmzVcOrderFilesUploadApi(params)
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (200 !== status) {
        this.$message.error(this.$l('INDEX.uploader_label_status_error'))
        return
      }

      this.$message({
        showClose: true,
        message: this.$l('INDEX.uploader_label_status_success') || '上传成功',
        type: 'success',
      })

      this.getData()
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-danger {
  padding: 1px 5px;
  border-left: 3px solid $color-danger;
  height: 20px;
  margin-top: 3px;
}
</style>
